import { TooltippedIcon } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { advancedReturningClassificationIconNameHandler } from '../../../../../accounts/utils';

export const TooltipedReturningIcon = ({ totalStays }: { totalStays: number }) => {
    const icon = advancedReturningClassificationIconNameHandler(totalStays);

    return <TooltippedIcon value={icon.iconName} size="small" tooltip={lt('StayCount', { count: totalStays })} />;
};
